import React, { Component } from "react";
import Modal from "react-modal";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "../../common.css";
import LoadingPage from "@components/Loading/Loading";
import SelectOption from "@components/Select/SelectOption";
import config from "@config";
import errorFunctions from "@store/errorFunctions";
import utilityFunctions from "@store/utilityFunctions";
import "./StaffDetail.css";
import ErrorPage from "@pages/ErrorPage/ErrorPage";

Modal.setAppElement("body");

const cin7Options = [
  { label: "None", value: "no_access" },
  { label: "Partial", value: "partial" },
  { label: "All", value: "all" },
];

export default class StaffDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      detailsLoaded: false,
      details: null,
      id: null,
      showApproveModal: false,
      showDeclineModal: false,
      addComment: "",
      startPostageNumber: "",
      endPostageNumber: "",
      showDeleteModal: false,
      redirect: false,
      showOutOfWarrantyModal: false,
      showAddNote: false,
      addedNote: "",
      employee: null,
      ticketID: null,
      employeeID: null,
      storeLocationValue: null, // Changed from storeLocationLabel
      currentStoreLocationId: "",
      storeLocationId: "",
      storeLocationChanged: false,
      showAssignModal: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      service_centers: [],
      currentRole: "",
      name: "",
      email: "",
      cin7Name: "",
      isSubemo: false,
      cin7Access: { label: "None", value: "no_access" }, // Fixed: was "none"
    };
  }

  componentDidMount() {
    const id = this.props.computedMatch.params.id;
    this.setState({ id });
    this.retriveDetailStaff(id);
    this.retriveAllBrand();
    this.retriveAllRoles();
    this.retrieveListStaffServiceCenters(id);
  }

  retrieveListStaffServiceCenters = (staffId) => {
    this.setState({ loading: true });

    const endpoint = `${config.backendServer}employee/${staffId}/service-centers/`;

    this.props
      .protectedFetch(
        endpoint,
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((serviceCentersResponse) => {
        this.setState({
          loading: false,
          service_centers: serviceCentersResponse,
        });
      })
      .catch((error) => {
        console.log("Failed to retrieve service centers:", error);
        this.setState({ loading: false });
      });
  };

  retriveDetailStaff = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "employee/" + id + "/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          loading: false,
          detailsLoaded: true,
          details: res,
          isSubemo: res.is_subemo,
          cin7Access:
            cin7Options.find((x) => x.value === res.cin7_access) ||
            cin7Options[0],
          currentRole: res.user_role,
          storeLocationValue: res.store_location?.id
            ? {
                label: `${res.seller?.name || ""} - ${
                  res.store_location?.name || ""
                }`,
                value: res.store_location.id,
              }
            : null,
          currentStoreLocationId: res.store_location?.id || "",
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false, detailsLoaded: true });
      });
  };

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  deleteUserLocation = () => {
    let url = `${config.backendServer}store_location/${this.state.currentStoreLocationId}/remove_staff/${this.state.details.id}/`;
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      console.log(response.status);
      if (response.status === 204) {
        this.setState({ showConfirmDelete: false, loading: false });
        if (this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
      } else if (response.status === 406) {
        alert(
          `Delete is not allowed, User Service Center is already linked to ticket`,
        );
      } else if (response.status === 409) {
        alert(`User Service does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };

  addUserLocation = (userId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: this.state.details.id,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${this.state.storeLocationId}/add_staff/`,
        payload,
        options,
      )
      .then((res) => {
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({
          loading: false,
          showAddUser: false,
          data: tempUsers,
          employeeID: "",
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
      });
  };

  retriveAllRoles = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "roles/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({ loading: false, roles: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const id = this.props.computedMatch.params.id;
    const selectedBrandIds = Array.from(
      document.querySelectorAll("input[type='checkbox']:checked"),
    ).map((checkbox) => parseInt(checkbox.value));

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name || this.state.details.name,
      email: this.state.email || this.state.details.email,
      user_role: this.state.currentRole || this.state.details.user_role,
      is_subemo: this.state.isSubemo,
      cin7_access: this.state.cin7Access.value,
      cin7_name: this.state.cin7Name || this.state.details.cin7_name,
    };

    if (this.state.storeLocationId) {
      payload.store_location_id = this.state.storeLocationId;
    }

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        if (
          this.state.storeLocationChanged &&
          this.state.currentStoreLocationId
        )
          this.deleteUserLocation();
        else if (this.state.storeLocationChanged && this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
        this.setState({
          name: "",
          email: "",
          currentRole: "",
          loading: false,
          redirect: true,
        });

        this.retriveDetailStaff(id); //mini reload
      })
      .catch((e) => {
        alert(JSON.stringify(e));
        console.log("fail");

        this.setState({
          loading: false,
        });
      });
  };

  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/manage-staff"} />;
    }
    
    if (this.state.loading || !this.state.detailsLoaded) {
      return <LoadingPage />;
    }

    if (!this.state.details) {
      return <ErrorPage statusCode={404} />;
    }

    const details = this.state.details || {};

    return (
      <div className={"page"}>
        <div className="card">
          <h4 className={"card-header"}>Staff Detail #{details?.id}</h4>

          <form onSubmit={this.handleSubmit}>
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Full name:
                    </span>
                    <input
                      type="text"
                      id="name"
                      required={true}
                      defaultValue={this.state.fullName || details.name}
                      className="form-control"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      CIN 7 Access<span>:</span>
                    </label>
                    <Select
                      required
                      id="cin7Access"
                      options={cin7Options}
                      value={this.state.cin7Access}
                      placeholder="Select CIN7 access"
                      onChange={(e) => {
                        this.setState({
                          cin7Access: e,
                        });
                      }}
                    />
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Email:
                    </span>
                    <input
                      type="email"
                      id="email"
                      required={true}
                      defaultValue={details.email}
                      className="form-control"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Brands:
                    </span>
                    <span>
                      {this.state.brands.map((brand) => (
                        <div className="col-6" key={brand.id}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`brand-${brand.id}`}
                              defaultChecked={this.state.details?.brands?.some(
                                (activeBrand) => activeBrand.id === brand.id,
                              )}
                              value={brand.id}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`brand-${brand.id}`}
                            >
                              {brand.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </span>
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Role:
                    </span>
                    <span className="container d-flex gap-2">
                      <select
                        className="form-control custom-select"
                        value={this.state.currentRole}
                        onChange={this.handleRole}
                      >
                        {this.state?.roles
                          ?.filter(
                            (r) =>
                              r.name !== "Commercial Staff" &&
                              r.name !== "EDI Customer",
                          )
                          .map((val, i) => {
                            return (
                              <option key={i} id="currentRole" value={val.name}>
                                {val.name}
                              </option>
                            );
                          })}
                      </select>
                      {this.state.currentRole === "Staff" && (
                        <div className="form-check my-auto">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isSubemo"
                            checked={this.state.isSubemo}
                            onChange={(e) => {
                              console.log(e.target);
                              this.setState({ isSubemo: e.target.checked });
                            }}
                          />
                          <label className="form-check-label">Subemo</label>
                        </div>
                      )}
                    </span>
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      Store Location<span>:</span>
                    </label>
                    <SelectOption
                      apiEndpoint={
                        config.backendServer + "store_location/dropdown/"
                      }
                      placeholder="Select Location"
                      value={this.state.storeLocationValue}
                      onChange={(e) => {
                        this.setState({
                          storeLocationValue: e,
                          storeLocationId: e?.value || "",
                          storeLocationChanged:
                            this.state.currentStoreLocationId !== e?.value,
                        });
                      }}
                      // additionalParams={{
                      //   brand_id: utilityFunctions.getCookie("brandId") || "",
                      // }}
                      formatLabel={(item) => item.combine_name}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <h5>List service center:</h5>
                  {this.state.service_centers?.length > 0 ? (
                    <ul className="list-group">
                      {this.state.service_centers?.map((sc, i) => {
                        return (
                          <li className="list-group-item" key={i}>{`${
                            i + 1
                          }.  ${sc.name}`}</li>
                        );
                      })}
                    </ul>
                  ) : (
                    <div>No Data</div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col-3">
                  <button className={"btn btn-outline-primary"}>
                    Save Data
                  </button>
                </div>
                <div className="col-3">
                  <a
                    className={"btn btn-outline-secondary"}
                    href={"/manage-staff"}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
